import { Host, h } from '@stencil/core';
// import { data } from './_mock/mock.json';
export class AibaQuizVariationSubques {
  constructor() {
    this.type = undefined;
    this.selectedOptions = undefined;
    this.variantData = undefined;
    this.maxSelection = undefined;
    this.clickEvent = undefined;
    this.handlers = undefined;
    this.optionClasses = undefined;
    this.subQuesClasses = undefined;
    this.styles = undefined;
    this.questionId = undefined;
    this.classes = undefined;
    this.data = undefined;
    this.isPopulated = false;
    this.rerender = false;
    this.index = 0;
    this.filterValue = 0;
    this.rows = undefined;
    this.weatherDataValues = undefined;
    this.rowindex = undefined;
  }
  selectOptionsArrayValue(event) {
    this.weatherDataValues = event.detail;
  }
  componentWillLoad() {
    this.rows = this.data.reduce(function (rows, key, index) {
      return (index % 3 === 0 ? rows.push([key]) : rows[rows.length - 1].push(key)) && rows;
    }, []);
  }
  handleOptionSelected(option) {
    var _a, _b;
    this.rows.map((rowData, index) => {
      rowData.map(rowItem => {
        if (rowItem.answerId === option) {
          this.rowindex = index;
        }
      });
    });
    let rowEntryExit = false;
    let optionIndex = null;
    const filter = this.rows.map((_item, index) => {
      if (index === this.rowindex)
        return _item;
    });
    filter[this.rowindex].map((elem, childindex) => {
      var _a, _b, _c;
      if ((_a = this.selectedOptions) === null || _a === void 0 ? void 0 : _a.includes(this.rows[this.rowindex][childindex].answerId)) {
        if ((_b = this.selectedOptions) === null || _b === void 0 ? void 0 : _b.includes(elem.answerId)) {
          rowEntryExit = true;
          optionIndex = (_c = this.selectedOptions) === null || _c === void 0 ? void 0 : _c.indexOf(elem.answerId);
        }
      }
    });
    if (rowEntryExit) {
      if (optionIndex > -1) {
        (_a = this.selectedOptions) === null || _a === void 0 ? void 0 : _a.splice(optionIndex, 1);
      }
    }
    (_b = this.selectedOptions) === null || _b === void 0 ? void 0 : _b.push(option);
    if (this.handlers && this.handlers.handleQuizOptionSelected) {
      this.handlers.handleQuizOptionSelected([...this.selectedOptions], this.data[0].questionId, option);
    }
    this.rerender = !this.rerender;
  }
  isSelected(answerId) {
    var _a;
    return ((_a = this.selectedOptions) === null || _a === void 0 ? void 0 : _a.includes(answerId)) ? 'active ' : '';
  }
  getValue() {
    var _a;
    if (((_a = this.selectedOptions) === null || _a === void 0 ? void 0 : _a.length) > 0) {
      const data = this.selectedOptions[0] ? this.selectedOptions[0] : '';
      return data;
    }
    return '';
  }
  async componentWillRender() {
    var _a, _b;
    if (((_a = this.selectedOptions) === null || _a === void 0 ? void 0 : _a.length) > 0) {
      this.filterValue = (_b = this.selectedOptions) === null || _b === void 0 ? void 0 : _b.length;
    }
    else {
      this.filterValue = this.index;
    }
  }
  render() {
    const rowMap = !this.isPopulated ? this.rows.filter((_item, index) => index <= this.filterValue) : this.rows;
    return (h(Host, null, this.styles && h("style", null, this.styles), rowMap.map((options) => (h("aiba-grid-item", { classes: (options === null || options === void 0 ? void 0 : options.optionClasses) ? options === null || options === void 0 ? void 0 : options.optionClasses : ' ' }, h("div", { class: (options === null || options === void 0 ? void 0 : options.subQuesClasses) ? options === null || options === void 0 ? void 0 : options.subQuesClasses : 'textBlock' }, options[0].text), h("div", { class: "options" }, options.map(option => (h("div", { tabIndex: 0, role: "button", "aria-label": option === null || option === void 0 ? void 0 : option.answerText, "data-answerId": option === null || option === void 0 ? void 0 : option.answerId, key: option === null || option === void 0 ? void 0 : option.answerId, class: (option === null || option === void 0 ? void 0 : option.classes) + ' ' + this.isSelected(option === null || option === void 0 ? void 0 : option.answerId), onClick: () => this.handleOptionSelected && this.handleOptionSelected(option === null || option === void 0 ? void 0 : option.answerId), onKeyDown: event => {
        if (event.key === 'Enter') {
          event.stopPropagation();
          this.handleOptionSelected && this.handleOptionSelected(option === null || option === void 0 ? void 0 : option.answerId);
        }
      } }, h("div", Object.assign({ class: "option-wrapper__option-title" }, this.variantData), option === null || option === void 0 ? void 0 : option.answerText), ' ')))))))));
  }
  static get is() { return "option-variation-with-subquestions"; }
  static get originalStyleUrls() {
    return {
      "$": ["option-variation-with-subquestions.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["option-variation-with-subquestions.css"]
    };
  }
  static get properties() {
    return {
      "type": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "'multiple'",
          "resolved": "\"multiple\"",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "type",
        "reflect": false
      },
      "selectedOptions": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "selected-options",
        "reflect": false
      },
      "variantData": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "variant-data",
        "reflect": false
      },
      "maxSelection": {
        "type": "number",
        "mutable": false,
        "complexType": {
          "original": "number",
          "resolved": "number",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "max-selection",
        "reflect": false
      },
      "clickEvent": {
        "type": "number",
        "mutable": false,
        "complexType": {
          "original": "number",
          "resolved": "number",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "click-event",
        "reflect": false
      },
      "handlers": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "handlers",
        "reflect": false
      },
      "optionClasses": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "option-classes",
        "reflect": false
      },
      "subQuesClasses": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "sub-ques-classes",
        "reflect": false
      },
      "styles": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "styles",
        "reflect": false
      },
      "questionId": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "question-id",
        "reflect": false
      },
      "classes": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "classes",
        "reflect": false
      },
      "data": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "data",
        "reflect": false
      },
      "isPopulated": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "is-populated",
        "reflect": false,
        "defaultValue": "false"
      },
      "rows": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "rows",
        "reflect": false
      },
      "rowindex": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "rowindex",
        "reflect": false
      }
    };
  }
  static get states() {
    return {
      "rerender": {},
      "index": {},
      "filterValue": {},
      "weatherDataValues": {}
    };
  }
  static get events() {
    return [{
        "method": "selected",
        "name": "selected",
        "bubbles": true,
        "cancelable": true,
        "composed": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "complexType": {
          "original": "string[]",
          "resolved": "string[]",
          "references": {}
        }
      }];
  }
  static get listeners() {
    return [{
        "name": "selectOptionsArrayValue",
        "method": "selectOptionsArrayValue",
        "target": "window",
        "capture": false,
        "passive": false
      }];
  }
}
//# sourceMappingURL=option-variation-with-subquestions.js.map
